export default {
	'slider': 'Slider',
	'small_image_select': 'ImageSelect',
	'large_image_select': 'ImageSelect',
	'binary': 'Binary',
	'box_select': 'BoxSelect',
	'radio': 'Radio',
	'select': 'Select',
	'scroller': 'Scroller',
	'star': 'Star',
	'text': 'TextResponse',
	'image_upload': 'ImageUpload',
	'human_map': 'HumanMap',
	'multi_question': 'MultiQuestion',
	'long_text_bubble': 'LongTextBubble',
	'sign_document': 'SignDocument',
	'date': 'Date',
	'unit': 'Unit'
}
